'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var pMap = require('p-map');

var pTimes = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(count, mapper, options) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", pMap(new Array(count).fill(), function (element, index) {
              return mapper(index);
            }, options));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function pTimes(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

module.exports = pTimes; // TODO: Remove this for the next major release

module.exports.default = pTimes;